export default __webpack_public_path__ + "static/media/lib-template4.ac2448a4.png";